import React from "react";
import { UseFormRegister } from "react-hook-form";
import { ReconciliationFormData } from "../ReconciliationModal";

export const FinanceNoteInput = React.forwardRef<
  HTMLTextAreaElement,
  Partial<ReturnType<UseFormRegister<ReconciliationFormData>>>
>(function BaseFinanceNoteInput({ name, onChange }, ref) {
  return (
    <>
      <h5>Add a note for finance</h5>
      <textarea
        className="short"
        id="finance-note"
        data-testid="finance-note-input"
        name={name}
        onChange={onChange}
        ref={ref}
        placeholder="e.g. a specific person to send the invoice to"
      />
    </>
  );
});
